export default "__VITE_ASSET__TPH29GRo__"